import numeral from "numeral";
import i18n from "../i18n";

numeral.register('locale', 'id', {
    delimiters: {
        thousands: '.',
        decimal: ','
    },
    abbreviations: {
        thousand: 'rb',
        million: 'jt',
        billion: 'M',
        trillion: 'T'
    },
    currency: {
        symbol: 'Rp'
    }
});

const Numeral = {}
Numeral.install = function (Vue) {
    numeral.locale(i18n.locale)
    Vue.prototype.$numeral = numeral
}

export default Numeral
